export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_squad-inquiry-hub/artifacts/42rd99ug_Screenshot%202026-06-11%20at%2011.08.04%E2%80%AFAM.png";

export const FORM_IMAGE =
  "https://customer-assets.emergentagent.com/job_squad-inquiry-hub/artifacts/x0x4w1oi_WhatsApp%20Image%202026-06-11%20at%2011.13.07.jpeg";

export const NATURE_OPTIONS = [
  "Talent Agent",
  "Press Inquiry",
  "Investor Relations",
  "Licensing",
  "Production",
  "Distribution Inquiry",
  "Partnership Inquiry",
  "Merchandise",
  "Music / Soundtrack",
  "General Inquiry",
  "I'm a fan",
  "Other",
];

export const HEARD_OPTIONS = [
  "Instagram",
  "Facebook",
  "TikTok",
  "YouTube",
  "LinkedIn",
  "Google Search",
  "Press / Media Article",
  "Film Industry Contact",
  "Talent Agent / Manager",
  "Producer / Studio Referral",
  "Investor / Business Contact",
  "Friend or Family Referral",
  "Film Festival / Industry Event",
  "Newsletter / Email",
  "Website",
  "Other",
];

export const MOVIE = {
  title: "Fly Squad",
  subtitle: "First Strike",
  logline:
    "When her best friend collapses from a deadly new toxin, a bold young bee recruits a nervy firefly and a drama-queen spider for an impossible heist: infiltrate Malapro's Toxi City, steal the antidote, and escape before the poison wipes out every insect on Earth.",
  genre: "Animated Action-Comedy-Musical-Heist",
  audience: "Four-Quadrant: Families, Kids, Teens, Adults",
  instagramHandle: "flysquadmovie",
};

export const MEDIA_CONTACT = {
  name: "Kathryn McGowan",
  role: "Public Relations, Australia",
  email: "kathryn@kmpr.com.au",
  phone: "+61 414 529 805",
};

export const PRESS_RELEASE = {
  title:
    "Oscar-Nominated Composer Walter Murphy Joins Fly Squad — First Strike!",
  date: "",
  url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_7a2c6679-e876-4d07-a35e-26d9742689dc/artifacts/f7hdaur6_Fly-Squad-Walter-Murphy-Press-Release.pdf",
};

// Older / archived press releases, shown as clickable title links beneath the
// latest one. Newest-first.
export const PAST_PRESS_RELEASES = [
  {
    title:
      "Cher and Sir Bob Geldof in Talks to Board Animated Feature Fly Squad — First Strike!",
    date: "June 12, 2026",
    url: "https://customer-assets.emergentagent.com/job_7a2c6679-e876-4d07-a35e-26d9742689dc/artifacts/w2denp7s_Fly%20Squad%20Press%20Release%201%20%281%29.pdf",
  },
];
